import { ReduxViewEntity } from '../types'

export const getSortedInfo = (view?: ReduxViewEntity) =>
  view?.display_settings?.sorted_by?.[0] ??
  view?.output.schema?.sorted_fields?.[0]
